var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueryplusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14510 17043)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15129 -17617)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(619 574)",
    fill: "#98a2b2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.764 1.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14528.482 -17040)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 7.437,
    transform: "translate(3.691)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x2: 7.437,
    transform: "translate(0 3.691)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryplusIcon);
export default __webpack_public_path__ + "static/media/queryplus-icon.877b311cfba3d817ecaa59aa734e749f.svg";
export { ForwardRef as ReactComponent };